import './skeleton.scss';
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme } from '..';
const Skeleton = _ref => {
  let {
    className,
    type
  } = _ref;
  const {
    theme
  } = useTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('wrts-skeleton', type, className, theme)
  });
};
Skeleton.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string
};
export default /*#__PURE__*/memo(Skeleton);